import React from 'react';

import Layout from '../components/Layout';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 
import a from '../assets/images/a-xx-150-art.jpg';
import b from '../assets/images/a-xx-151-art.jpg';
import c from '../assets/images/a-xx-152-art.jpg';
import d from '../assets/images/a-xx-153-art.jpg';
import e from '../assets/images/a-xx-154-art.jpg';
import f from '../assets/images/a-xx-155-art.jpg';
import g from '../assets/images/a-xx-156-art.jpg';
import h from '../assets/images/a-xx-157-art.jpg';
import i from '../assets/images/a-xx-158-art.jpg';
import j from '../assets/images/a-xx-159-art.jpg';


const pillars = [
  [
    {
      img: a,
      title:'Kolam Design',
      text: 'This is a kolam, the traditional household and priestly art of drawing intricate, decorative patterns at the entrance to a home or temple or at the site of a religious ceremony. They bring auspiciousness to the space. Known as rangoli in Sanskrit. Kolam designs are made with rice powder mixed to a watery paste, and sometimes with flowers and various-colored powdered pulses and flours.'
    },
    {
      img: b,
      title:'Taro Plant',
      text: 'This is the taro plant, Colocasia esculenta, a tropical plant grown primarily for its edible corms, a root vegetable. There are large fields of taro grown in Hanalei valley here on Kauai where it is known as kalo. It is the most widely cultivated species of several plants in the family Araceae. Taro corms are a food staple in African, Oceanic and South Asian cultures (similar to yams), and taro is believed to have been one of the earliest cultivated plants.'
    },
    {
      img: c,
      title:'Tulsi or Basil Plant',
      text: 'This is the tulsi plant, Ocimum tenuiflorum (synonym: Ocimum sanctum), commonly known as holy basil, tulasi (sometimes spelled thulasi) or tulsi. It is an aromatic perennial plant native to the Indian subcontinent and widespread as a cultivated plant throughout the Southeast Asian tropics.\
      Tulsi is cultivated for religious and traditional medicine purposes, and for its essential oil. It is widely used as a herbal tea, commonly used in Ayurveda, and has a place within the Vaishnava tradition of Hinduism, in which devotees perform worship involving holy basil plants or leaves.'
    },
    {
      img: d,
      title:'Sacred Homa Fire',
      text: 'This is the homa kunda, a special pit in which a holy fire is lit during Hindu worship, weddings and other events. Also called a havana.'
    }
  ],
  
  [
    {
      img: e,
      title:'Ethical Restraints',
      text: 'Here a seeker’s legs are held together with a strap in a common yogic pose. It represents the yamas, or ethical restraints, of which there are ten. The yamas are the ethical restraints; the niyamas are the religious practices. Because it is brief, the entire code can be easily memorized and reviewed daily by the spiritual aspirant. Here are the ten traditional yamas: 1) ahimsa: “Noninjury.” Not harming others by thought, word, or deed. 2) satya: “Truthfulness.” Refraining from lying and betraying promises. 3) asteya: “Nonstealing.” Neither stealing nor coveting, nor entering into debt. 4) brahmacharya: “Divine conduct.” Controlling lust by remaining celibate when single, leading to faithfulness in marriage. 5) kshama: “Patience.” Restraining intolerance with people and impatience with circumstances. 6) dhriti: “Steadfastness.” Overcoming nonperseverance, fear, indecision and changeableness. 7) daya: “Compassion.” Conquering callous, cruel and insensitive feelings toward all beings. 8) arjava: “Honesty, straightforwardness.” Renouncing deception and wrongdoing. 9) mitahara: “Moderate appetite.” Neither eating too much nor consuming meat, fish, fowl or eggs. 10) saucha: “Purity.” Avoiding impurity in body, mind and speech.'
    },
    {
      img: f,
      title:'Yoga Postures',
      text: 'Here we have asana, meaning “seat; posture.” In hatha yoga, asana refers to any of numerous poses prescribed to balance and tune up the subtle energies of mind and body for meditation and to promote health and longevity. Examples are the shoulder-stand (sarvangasana, “whole body pose”) and the lotus pose (padmasana). Each asana possesses unique benefits, affecting the varied inner bodies and releasing energies in different parts of the nervous system. While the physical science of hatha yoga can dramatically influence health and general well-being, it is primarily intended as a preparation for the deeper yogas and meditations. Sivaya Subramuniyaswami has provided a system of 24 asanas to tune the nervous system for meditation and contemplation and to mitigate the burdensome karmas, known by the modern term “stress,” built up through the interaction with other people. His 24 asanas are performed in a meditative sequence, not unlike a serene dance, accompanied by certain visualizations and pranayamas.'
    },
    {
      img: g,
      title:'Religious Observances',
      text: 'A devotee holds a rudraksha mala and is counting the beads in performance of japa yoga. This represents the niyamas, which literally means “to unleash.” The niyamas are ethical and religious practices which release or cultivate refined, soul qualities. These observances comprise the second limb of the ashtanga (“eight-limbed”) yoga system codified in numerous Saivite scriptures including the Sandilya and Varuha Upanishads, Hatha Yoga Pradipika by Sri Gorakhnath, the Tirumantiram (circa 200 BCE) by Saint Tirumular and the Yoga Sutras (circa 200 BCE) of Sage Patanjali. There are ten yamas and ten niyamas in all, though Patanjali listed only five yamas and five niyamas in his classic work, and these have become widely known. Along with the yamas (restraints), the niyamas provide guidelines for ethical, moral life and lay the foundation for yoga. The ten niyamas are: 1) santosha (contentment), 2) tapaha (austerity), 3) dana (charity), 4) astikya (faith), 5) Isvarapujana (worship), 6) mati (cognition), 7) Siddhantasravana (scriptural study), 8) hri (remorse), 9) vrata (sacred vows) and 10) japa (recitation). Note that Sage Patanjali’s niyamas are saucha (purity, which other texts list as a yama), santosha, tapaha, svadhaya (scriptural study) and Isvarapranidhana (worship).'
    },
    {
      img: h,
      title:'Breath Control',
      text: 'This man is performing pranayama, which means “life-force restraining, breath control.” It is the yogic science of controlling prana (life force or vital energy) through breathing techniques which dictate the lengths of inhalation, retention and exhalation; prepares the mind for deep meditation and develops psychic abilities. It is the fourth stage of ashtanga yoga.'
    }
   ],

    [
      {
        img: i,
        title:'Four States of Being',
        text: 'Four states of being. This is Shum script for law, lawm, lawf, lawmf. It is a meditation in Gurudeva’s language of meditation and one of the 12 meditations he asked us to carve on the pillars. It describes four states of our being. The first is law, the physical body. The second is lawm, the emotional-intellectual nature. The third is lawf, the shakti of the individual soul radiating from the source into and through the physical body. The fourth, lawmf, describes the energies within the actinic body of a realized being after many instances of imkaif.'
      },
      {
        img: j,
        title:'Religious Lifestyle',
        text: 'Religious lifestyle. This is Shum script for kanef, shumtyaef, tyashum. It is a meditation in Gurudeva’s language of meditation and one of the 12 meditations he asked us to carve on the pillars. Kanef is the contemplative lifestyle found within the structure and vocabulary of the Shum language, which leads to Self-Realization and the feeling of being the center of the universe. Shumtyaef names the mystical language created by Gurudeva in 1968, and is synonymous with the shorter form, Shum. Tyeshum is a Shum lexicon and the hand-written book of a Shum student.'
      },
      {
        img: '',
        title:'',
        text: ''
      },
      {
        img: '',
        title:'',
        text: ''
      }


   ]
];
 

const Pillar16 = () => (

  
  <Layout fullMenu>
    <article id="main">
      <header style={{marginBottom:0}}>
      
        <h2 style={{color:'#dd7137'}}>Pillar Sixteen</h2>
        <p>Artwork by A. Manivelu </p>
      </header>
      

    

<section className=" style4">     
        <div  > 
 
<div style={{maxWidth:500, padding: 10,marginLeft:'auto', marginRight:'auto'}}>
<h4 style={{textAlign:'center'}}>Top</h4>
         <Carousel showArrows={false}>
                <div>
                    <img className="image" src={pillars[0][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[0][0].title}</h4>
                    <p>{pillars[0][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[0][1].title}</h4>
                    <p>{pillars[0][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[0][2].title}</h4>
                    <p>{pillars[0][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[0][3].title}</h4>
                    <p>{pillars[0][3].text}</p>
                </div>
            </Carousel> 


            <h4 style={{textAlign:'center'}}>Middle</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[1][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[1][0].title}</h4>
                    <p>{pillars[1][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[1][1].title}</h4>
                    <p>{pillars[1][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[1][2].title}</h4>
                    <p>{pillars[1][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[1][3].title}</h4>
                    <p>{pillars[1][3].text}</p>
                </div>
            </Carousel> 
            <h4 style={{textAlign:'center'}}>Bottom</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[2][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[2][0].title}</h4>
                    <p>{pillars[2][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[2][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[2][1].title}</h4>
                    <p>{pillars[2][1].text}</p>
                </div>
                 
            </Carousel> 

            </div>

 
      

        </div>
      </section>
      
    </article>
  </Layout>
);

export default Pillar16;
